<script lang="ts" setup>
import { ref, reactive } from 'vue'
import { z } from 'zod'

const toast = useToast()

const passwordSchema = z.object({
  email: z
    .string({ required_error: 'Požadované' })
    .email('Neplatný email'),
  password: z
    .string({ required_error: 'Požadované' })
    .min(8, 'Musí mít alespoň 8 znaků'),
})

const { fetch: refreshSession } = useUserSession()

const state = reactive({
  email: undefined,
  password: undefined,
})

const loading = ref(false)

async function onSubmit(event) {
  try {
    loading.value = true
    await $fetch('/api/auth/login-with-password', {
      method: 'POST',
      body: event.data,
    })
    await refreshSession()
    toast.add({
      id: `logged_in`,
      title: `Přihlášení bylo úspěšné.`,
      icon: 'i-heroicons-check-circle',
      timeout: 5000,
      color: 'green',
    })
    navigateTo('/')
  } catch (error) {
    loading.value = false
    toast.add({
      id: `log_in_error`,
      title: `Přihlášení nebylo úspěšné.`,
      icon: 'i-heroicons-x-circle',
      timeout: 5000,
      color: 'red',
    })
    // toast.error(error.data.statusMessage)
  }
}
</script>

<template>
  <UForm
    :schema="passwordSchema"
    :state="state"
    class="max-w-sm space-y-4"
    @submit="onSubmit"
  >
    <UFormGroup name="email" size="lg" required>
      <template #label>
        <UIcon
          name="heroicons:envelope"
          class="-mb-1 h-5 w-5 text-gray-400"
        />
        <span class="mx-1">Email</span>
      </template>
      <UInput v-model="state.email" class="mt-1"/>
    </UFormGroup>
    <UFormGroup name="password" size="lg" required>
      <template #label>
        <UIcon
          name="i-heroicons-lock-closed"
          class="-mb-1 h-5 w-5 text-gray-400"
        />
        <span class="mx-1">Heslo</span>
      </template>
      <UInput v-model="state.password" type="password" class="mt-1"/>
      <!--
      <template #hint>
        <UButton
          variant="link"
          :padded="false"
          to="/auth/forgot-password"
          size="xs"
          color="gray"
        >
          Zapomněli jste heslo?
        </UButton>
      </template>
      -->
    </UFormGroup>
    <UButton
      :loading="loading"
      color="orange"
      type="submit"
      :disabled="loading"
      size="lg"
      block
    >
      Přihlásit se
    </UButton>
  </UForm>
</template>
